import React from 'react';

import './css/app.scss'
import Main from './scripts/main';

function App() {
    var date = new Date(document.lastModified);
    var options = { year: 'numeric', month: 'short', day: 'numeric' };
    return (
        <div className="App">
            <header></header>
            <Main />
            <footer>Last update : {date.toLocaleDateString('en-US', options)} </footer>
        </div>
    );
}

export default App;
